// src/components/atoms/VideoElement.js

import React from "react";
import PropTypes from "prop-types";

const VideoElement = React.forwardRef(
  ({ src, onTimeUpdate, onLoadedMetadata }, ref) => {
    return (
      <video
        ref={ref}
        src={src}
        onTimeUpdate={(e) => onTimeUpdate(e.target.currentTime)}
        onLoadedMetadata={(e) => onLoadedMetadata(e.target.duration)}
        width="100%"
        style={{ maxWidth: "100%", borderRadius: "25px" }}
        controls={false} // We'll use custom controls
      >
        Your browser does not support the video tag.
      </video>
    );
  }
);

VideoElement.propTypes = {
  src: PropTypes.string.isRequired,
  onTimeUpdate: PropTypes.func.isRequired,
  onLoadedMetadata: PropTypes.func.isRequired,
};

export default VideoElement;
